import { Link, useLocation } from "react-router-dom";
import { STUDY_OPTIONS_PATH, PRACTICE_PATH, API_BASE_URL } from "../../constants";
import "./UnitsListPage.css";
import { useUnitData } from "../../database";
import { useEffect, useState } from "react";
import { FIREBASE_AUTH } from "../../FirebaseConfig";
import { onAuthStateChanged } from "firebase/auth";

const GAMES = {
  hideandseek:        "Hide & Seek",
  jumprope:           "Jump Rope",
  redlightgreenlight: "Red Light",
  tug:                "Tug of War",
  jegi:               "Jegi",
  marble:             "Marbles",
  mingle:             "Mingle",
  flyingstone:        "Flying Stone",
  sugar:              "Sugar",
  gonggi:             "Gong Gi",
};

function getColor(accuracy, attempted) {
  if (!attempted) return { bg: "#e0e0e0", text: "#888" };
  if (accuracy >= 70) return { bg: "#4caf50", text: "#fff" };
  if (accuracy >= 40) return { bg: "#ffc107", text: "#fff" };
  return { bg: "#f44336", text: "#fff" };
}

function getUnitOverall(unitProgress) {
  let totalCorrect = 0;
  let totalAttempted = 0;
  Object.values(unitProgress).forEach(({ attempted, accuracy }) => {
    totalAttempted += attempted;
    totalCorrect += Math.round((accuracy / 100) * attempted);
  });
  const overall = totalAttempted > 0 ? Math.round((totalCorrect / totalAttempted) * 100) : null;
  return { overall, totalAttempted };
}

function UnitCard({ unit, progressMap }) {
  const unitProgress = progressMap[unit.unit] || {};
  const { overall, totalAttempted } = getUnitOverall(unitProgress);
  const { bg, text } = getColor(overall ?? 0, totalAttempted);

  return (
    <Link to={STUDY_OPTIONS_PATH} state={unit} className="unit-card-link">
      <div className="unit-card">
        <div className="unit-card-name">{unit.name}</div>
        <div className="unit-focus-row">
          <div
            className="unit-game-badge"
            style={{ background: bg, color: text }}
          >
            {overall !== null ? (
              <>
                <span className="badge-label">Overall</span>
                <span className="badge-pct">{overall}%</span>
              </>
            ) : (
              <span className="badge-label">Not played yet</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}

function UnitsListPage() {
  const location = useLocation();
  const data = location.state;
  const { data: unitData } = useUnitData(data.textbook);
  const [progressMap, setProgressMap] = useState({});

  useEffect(() => {
    const unsub = onAuthStateChanged(FIREBASE_AUTH, (user) => {
      if (!user) return;
      fetch(`${API_BASE_URL}/get_progress?user=${user.email}`)
        .then((r) => r.json())
        .then((rows) => {
          const map = {};
          rows
            .filter((r) => r.textbook === data.textbook)
            .forEach((r) => {
              if (!map[r.unit]) map[r.unit] = {};
              map[r.unit][r.game] = {
                attempted: r.attempted,
                accuracy: r.attempted > 0 ? Math.round((r.number_correct / r.attempted) * 100) : 0,
              };
            });
          setProgressMap(map);
        })
        .catch(console.error);
    });
    return () => unsub();
  }, [data.textbook]);

  return (
    <div className="units-container">
      <div className="white-background">
        <h1>Units</h1>
        <div className="units-grid">
          {unitData && Object.values(unitData).map((unit) => (
            <UnitCard key={unit.unit} unit={unit} progressMap={progressMap} />
          ))}
        </div>
        <Link to={PRACTICE_PATH}>
          <button className="back-button">Back</button>
        </Link>
      </div>
    </div>
  );
}

export default UnitsListPage;
